import { tv } from 'tailwind-variants';

const containerStyles = tv({
  base: 'flex flex-col gap-y-4 w-full max-w-[250px]',
});

const labelStyles = tv({
  base: '',
  variants: {
    design: {},
    errored: {
      true: 'text-red-500',
    },
  },
});

const contentStyles = tv({
  base: 'relative max-w-[250px] w-full flex gap-x-2 h-14',
  variants: {
    design: {},
  },
});

const inputStyles = tv({
  base: 'absolute top-0 right-0 bottom-0 left-0 box-border bg-transparent text-transparent border-0 outline-none selection:bg-transparent w-full',
  variants: {
    design: {},
    disabled: {
      true: 'disabled:cursor-not-allowed disabled:text-gray-700 read-only:cursor-not-allowed read-only:text-gray-700',
    },
  },
});

const codeStyles = tv({
  base: 'h-full border text-lg flex-grow basis-0 select-none cursor-default flex items-center justify-center font-medium',
  variants: {
    design: {},
    inactive: {
      true: 'bg-secondary-one bg-opacity-10',
    },
    selected: {
      true: 'border-2 border-solid',
    },
    filled: {
      true: '',
    },
    errored: {
      true: 'border-red-500',
    },
  },
});

export const pinStyles = {
  container: containerStyles,
  label: labelStyles,
  content: contentStyles,
  input: inputStyles,
  code: codeStyles,
};
